import { LucideChevronLeft } from 'lucide-react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
  hideBackButton?: boolean;
};

export const Header: FC<Props> = ({ hideBackButton = false }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-row justify-between px-4 bg-white border-solid border-b-[1px] top-0 left-0 right-0 fixed">
      {!hideBackButton ? (
        <button
          onClick={() => {
            navigate(-1);
          }}
        >
          <LucideChevronLeft className="text-icon" />
        </button>
      ) : (
        <div></div>
      )}
      <img src="/up-waste-logo.svg" onClick={() => navigate('/')} />
      <div></div>
    </div>
  );
};
